import styled from 'styled-components';
import { Table } from 'antd';

export default styled(Table).attrs({ className: 'table-component' })`
  .ant-table {
    color: #262626;
    font-size: 13px;
    .ant-table-thead > tr > th {
      font-weight: normal;
      background: #fff;
    }
    .ant-table-thead > tr:nth-child(2) > th {
      color: #9797a6;
    }
    .ant-legacy-form-item-control {
      line-height: 1;
    }
    .ant-table-content > .ant-table-body > table > .ant-table-tbody > tr > td {
      padding-top: 0;
      padding-bottom: 0;
      line-height: 1;
      height: 40px;
      justify-content: center;
      align-items: center;
    }
    .ant-table-row-level-0 {
      background: #f4f4f4;
      font-weight: bold;
    }
    .ant-table-content
      > .ant-table-body
      > table
      > .ant-table-tbody
      > tr.ant-table-row-level-1
      > td:first-child {
      color: #595959;
      padding-left: 24px;
    }
    .ant-table-row-indent {
      padding-left: 800px;
    }
    .ant-table-row-expand-icon {
      line-height: 17px;
    }
    .ant-table-row.new-row.hightlight {
      > td:not(.cell-editing-mode).editable {
        > .hightlightWrapper {
          border: 1px solid #d9d9d9;
          border-radius: 4px;
          padding: 5px 8px 5px 48px;
          margin-right: -8px;
        }
      }
    }
    .ant-table-row.ant-table-row-level-1 .cell-editing-mode {
      padding-left: 40px;
    }
    .ant-legacy-form-item-children {
      margin-right: -8px;
    }
    .total-row {
      background: #d1d1d1 !important;
    }
    .cell-editing-mode {
      padding-top: 0 !important;
      padding-bottom: 0 !important;
      transition-duration: 0s;
    }
    .cell-delete {
      button {
        padding: 4px;
      }
    }
    .ant-input-number {
      width: 66px;
      height: 28px;
      padding-top: 3px;
      .ant-input-number-handler-wrap {
        display: none;
      }
      .ant-input-number-input {
        padding: 0 7px;
        text-align: right;
        height: 100%;
      }
    }
    .ant-form-explain {
      right: 0;
    }
    .footer-row {
      background: #f5f5f5;
    }
    .total-row {
      background-color: #e8e8e8;
      font-weight: bold;
    }
  }
`;
